export default __webpack_public_path__ + "static/media/Emma-Darko-CV.4a3ed0af.pdf";